@if (starting()) {
  <div class="startup-screen">
    @if (startupError()) {
      <section class="startup-error" role="alert">
        <h1>Platform Admin couldn't open</h1>
        <p>Please try loading the page again.</p>
        <button type="button" (click)="reload()">Retry</button>
      </section>
    } @else {
      <app-platform-loading-state />
    }
  </div>
}
<router-outlet />
